import routes from "@/routes";
import { lazy } from "react";

// Top-level "Line Items" module — cross-campaign DISPLAY line-item list. Distinct
// from the campaign-nested `lineItem.routes.tsx` (do NOT edit that one). Gated in
// main.routes.tsx on MODULES.CAMPAIGNS (the display edit route it links to lives
// under GeneralCampaignRoutes, which is CAMPAIGNS-only).
const ListLineItems = lazy(() => import("@/modules/LineItems"));

const LineItemsRoutes = {
  path: routes.LINE_ITEMS.INDEX,
  element: <ListLineItems />,
};

export default LineItemsRoutes;
